export default "__VITE_ASSET__kMdHHYAW2dQoXbLjilgvBw__";